import { Backdrop, Box, Button, ButtonGroup, CircularProgress, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { Form, Input, Space } from 'antd';
import Table from '../../../TableResizable';
import { createRef, useEffect, useRef, useState } from 'react';
import { DataSaverOn } from '@mui/icons-material';
import { ColumnsType } from 'antd/es/table';
import SweetAlert from "sweetalert2";
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';
import { PDFExport } from '@progress/kendo-react-pdf';
import INTDEB from '../../../../Models/INTDEB';
import Data from '../../../../Data/Data.json';
import { Crypter } from '../../../../Functions/Security/Crypter';
import Utilisateur from '../../../../Models/Utilisateur';
import formatNumber from '../../../../Functions/Traitement/FormatNumber';
import ExcelIcon from '../../../../Res/ExcelIcon.svg';
import ExcelIntDeb from '../../../../Models/ExcelIntDeb';
import ReformatNumber from '../../../../Functions/Traitement/ReformatNumber';
import { CellOptions } from '@progress/kendo-react-excel-export/dist/npm/ooxml/CellOptionsInterface';
import { useAgence } from '../../../../AgenceContext';
import { PrintCalculEOMDirect } from '../../../../utilitaires/globalFunction';


const column: ColumnsType<INTDEB> = [
    {
        title: 'Agence ',
        dataIndex: 'AEDUCP',
        width: 150,
        ellipsis: true,
    },
    {
        title: 'NUMCPT',
        dataIndex: 'NODUCP',
        align: 'left',
        ellipsis: true,
        width: 150,
    },
    {
        title: 'NOMCPT',
        dataIndex: 'NOMCPT',
        align: 'left',
        ellipsis: true,
        width: 150,
    },
    {
        title: 'MONTANT',
        dataIndex: 'MONTAN',
        align: 'left',
        width: 100,
        ellipsis: true,
    },
    {
        title: 'TXMONT',
        dataIndex: 'TXMONT',
        width: 100,
        ellipsis: true,
    },
    {
        title: 'SENS',
        dataIndex: 'SENSEC',
        width: 100,
        ellipsis: true,
    },
    {
        title: 'LIBELLE',
        dataIndex: 'LIBELL',
        ellipsis: true,
        width: 300,
        
    },
    {
        title: 'REPECE',
        dataIndex: 'REPECE',
        ellipsis: true,
        width: 100,
    },
    {
        title: 'montfrais',
        dataIndex: 'montfrais',
        width: 100,
    },
    {
        title: 'Solde Veille',
        dataIndex: 'solvei',
        width: 100,
        ellipsis: true,
    },
    {
        title: 'UTISAI',
        dataIndex: 'UTISAI',
        ellipsis: true,
        width: 100,
    }
];


const Tab2 = (props: { form: any }) => {
    const [DataInteret, SetDataInteret] = useState<INTDEB[]>([]);
    const [value, setValue] = useState(1);
    const [loading, setLoading] = useState(false);
    const auth = useAuthUser();
    const Branch=useAgence();
    const navigate = useNavigate();
    const user: Utilisateur = JSON.parse(JSON.stringify(auth()))
    // USER TOKEN
    const authHeader = useAuthHeader();
    const [start, setstart] = useState(false);
    const [DataExcel, SetDataExcel] = useState<ExcelIntDeb[]>([]);

    const pdfExportComponent = useRef<PDFExport>(null);
    const _exporter = createRef<ExcelExport>();


    const exportExcel = () => {
        if (DataInteret.length === 0) {
            SweetAlert.fire({ title: "Aucune donnée à exporter", icon: "warning" });
            return;
        }

        setLoading(true);

        const rows: ExcelIntDeb[] = DataInteret.map((data: any, indice: number) => ({
            key: indice,
            AEDUCP: data.AEDUCP,
            NODUCP: data.NODUCP,
            numcli: data.numcli,
            NOMCPT: data.NOMCPT,
            LECECP: data.LECECP,
            MONTAN: ReformatNumber(data.MONTAN || 0),
            TXMONT: ReformatNumber(data.TXMONT || 0),
            TYPOPE: data.TYPOPE,
            SENSEC: data.SENSEC,
            CDLBEC: data.CDLBEC,
            DATECR: data.DATECR,
            LIBELL: data.LIBELL,
            REPECE: data.REPECE,
            DEDEVR: data.DEDEVR,
            CDEEXO: data.CDEEXO,
            CDDEVS: data.CDDEVS,
            CODANA: data.CODANA,
            INTAUX: data.INTAUX,
            INTYPE: data.INTAUX,
            TYPCALC: data.TYPCALC,
            CODIFIE: data.CODIFIE,
            montfrais: ReformatNumber(data.montfrais || 0),
            solvei: ReformatNumber(data.solvei || 0),
            UTISAI: data.UTISAI
        }));

        const totalMontant = rows.reduce((acc: number, cur: any) => acc + ReformatNumber(cur.MONTAN || 0), 0);
        const totalFrais = rows.reduce((acc: number, cur: any) => acc + ReformatNumber(cur.montfrais || 0), 0);
        const totalSoldeVeille = rows.reduce((acc: number, cur: any) => acc + ReformatNumber(cur.solvei || 0), 0);

        rows.push({
            key: 'total',
            DATECR: 'TOTAL',
            LIBELL: 'TOTAL',
            MONTAN: totalMontant,
            montfrais: totalFrais,
            solvei: totalSoldeVeille
        } as ExcelIntDeb);

        rows.push({
            key: 'count',
            DATECR: 'NB',
            LIBELL: `${DataInteret.length} opération(s)`,
            MONTAN: DataInteret.length
        } as ExcelIntDeb);

        SetDataExcel(rows);

        if (!_exporter.current) {
            setLoading(false);
            return;
        }

        setTimeout(() => {
            _exporter.current?.save();
        }, 0);
    };

    

    const handleChange = (
        event: React.MouseEvent<HTMLElement>,
        newAlignment: number,
    ) => {
        if (newAlignment > 0 && newAlignment !== value) {
            setValue(newAlignment);
            GetCalculEOM(newAlignment);
        }
    };


    useEffect(
        () => {
            if (start === false) {
                GetCalculEOM(value);
                setstart(true)
            }
        },
        []);

    const headerCellStyle: CellOptions = {
        textAlign: 'center',
        background: '#ffffff',
        fontSize: 16
      
    };

    const GetCalculEOM = async (Option: number) => {
        SetDataInteret([]);
        props.form.setFieldsValue({ "TotalDebit": '', "TotalCrebit": '', "Nbrdebit": '', "NbrCrebit": '', "Total": '', "NbrOpe": '' });

        setLoading(true);
        var config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.GetCalculEOM,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authHeader(),
                'CypherCodu': Crypter.encrypt(user.coduti),
                'CypherAgence': Crypter.encrypt(user.codage),
                'CypherOption': Crypter.encrypt(Option.toString()),
            }
        };

        await
            axios(config)
                .then((response) => {
                    if (response.data) {
                        const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                        if (res.StatutCode == 200) {
                            if (res.Result.length > 0) {

                                let Datat: INTDEB[] = [];
                                let TotalC: number = 0;
                                let Nbre: number = 0;
                                let TotalDebit: number = 0;
                                let TotalCrebit: number = 0;
                                let NbrCrebit: number = 0;
                                let Nbrdebit: number = 0;

                                res.Result.map((data: any, indice: number) => {
                                   
                                    if (data.SENSEC === 'C') { Nbrdebit++; TotalDebit += data.MONTAN }
                                    else { NbrCrebit++; TotalCrebit += data.MONTAN }

                                    Datat.push({
                                        key: indice,
                                        AEDUCP: data.AEDUCP,
                                        NODUCP: data.NODUCP,
                                        numcli: data.numcli,
                                        NOMCPT: data.NOMCPT,
                                        LECECP: data.LECECP,
                                        MONTAN: formatNumber(data.MONTAN ? data.MONTAN : ''),
                                        TXMONT: formatNumber(data.TXMONT ? data.TXMONT : ''),
                                        TYPOPE: data.TYPOPE,
                                        SENSEC: data.SENSEC,
                                        CDLBEC: data.CDLBEC,
                                        DATECR: data.DATECR,
                                        LIBELL: data.LIBELL,
                                        REPECE: data.REPECE,
                                        DEDEVR: data.DEDEVR,
                                        CDEEXO: data.CDEEXO,
                                        CDDEVS: data.CDDEVS,
                                        CODANA: data.CODANA,
                                        INTAUX: data.INTAUX,
                                        INTYPE: data.INTAUX,
                                        TYPCALC: data.TYPCALC,
                                        CODIFIE: data.CODIFIE,
                                        montfrais: formatNumber(data.montfrais ? data.montfrais : ''),
                                        solvei: formatNumber(data.solvei ? data.solvei : ''),
                                        UTISAI: data.UTISAI
                                    })
                                })

                                SetDataInteret(Datat);
                                TotalC = TotalDebit - TotalCrebit;
                                Nbre= Nbrdebit -NbrCrebit
                                
                                props.form.setFieldValue("TotalDebit", formatNumber(TotalDebit));
                                props.form.setFieldValue('TotalCrebit', formatNumber(TotalCrebit));
                                props.form.setFieldValue("NbrCrebit", NbrCrebit);
                                props.form.setFieldValue("Nbrdebit", Nbrdebit);
                                props.form.setFieldValue("Total", formatNumber(TotalC));
                                props.form.setFieldValue("NbrOpe", Nbre);
                                setLoading(false);
                            }
                            else SweetAlert.fire({ title: 'Error', text: "Aucun élément retourné", icon: "warning" })
                        }
                        else {
                            SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" })
                        }
                    }
                    setLoading(false);

                }).catch((error) => {
                    console.log(error)
                    setLoading(false);
                    SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
                })
    }


    const HandlerPrint = () => {
        localStorage.removeItem(Data.LocalVariable.tabINTDEB);
        let Titre: string = "";
        switch (value) {
            case 1:
                {
                    Titre = "INTERETS DEBITEUR ";
                    break;
                }
            case 2:
                {
                    Titre = "COMMISSION  ";
                    break;
                }
            case 3:
                {
                    Titre = "INTERETS CREDITEUR";
                    break;
                }
        }

        let Total = props.form.getFieldValue('Total');
        localStorage.removeItem((Data.LocalVariable.tabINTDEB))
        localStorage.setItem(Data.LocalVariable.tabINTDEB, JSON.stringify({ "columns": column, "data": DataInteret, 'Total': Total, 'Titre': Titre }));
       // navigate("/Calculinteret/PrintINTDEB");
        PrintCalculEOMDirect(
                                                                Branch.agence?.BANQUE ?? '', 
                                                                 Branch.agence?.VILLE ?? '',
                                                                  Branch.agence?.BPOSTE ?? '',  
                                                                   Branch.agence?.TELEPH ?? '',              
                                                                user.codage,
                                                                user.agence,
                                                                user.nomuti ?? '',
                                                                user.coduti,
                                                                value.toString(),
                                                                "PDF"
                                                           )

    }

    const handleExport = () => {
        setLoading(false);
    }

    const headerOptions = {
        rows: [
            {
                height: 100,
                cells: [
                    {
                        value: "Mon entreprise",
                        textAlign: "center",
                        fontSize: 20,
                        background: "#ffffff"
                    }
                ]
            },
            {
                height: 100,
                cells: [
                    {
                        value: <img src={ExcelIcon} alt="Logo" />,
                        textAlign: "center",
                        background: "#ffffff"
                    }
                ]
            }
        ]
    };


    return (
        <div className='tabItem' >
            <Box fontStyle="inherit" className='border-left border' width={"95%"} position={"absolute"}>
                <Box style={{ display: 'flex', justifyContent: 'space-between', }} >
                    <Box width={'100%'}>
                        <ToggleButtonGroup value={value} onChange={handleChange} sx={{ width: '80%' }} aria-label="Platform" color="primary" exclusive>
                            <ToggleButton value={1}>  Interet  Débiteur  </ToggleButton>
                            <ToggleButton value={2}>  Commission         </ToggleButton>
                            <ToggleButton value={3}>  Interet Créditeur </ToggleButton>
                        </ToggleButtonGroup>
                    </Box>
                    <Box>
                        <ButtonGroup disabled={DataInteret.length <= 0 || loading === true ? true : false} disableElevation color='success' variant="outlined" aria-label="Disabled elevation buttons">
                            <Button ><PictureAsPdfIcon color='error' /> </Button>
                            <Button onClick={exportExcel}><img style={{ width: 25 }} src={ExcelIcon}></img> </Button>
                        </ButtonGroup>
                    </Box>
                </Box>
                <Box>
                </Box>
                <Box style={{ display: 'flex' }} >
                    <Box fontStyle="inherit" className='border-left' width={'100%'}>
                        <Table sticky={true} size='small' loading={loading} columns={column}  style={{ width: '100%' }} scroll={{ y: 340, x: 1200 }} dataSource={DataInteret} />
                    </Box>
                </Box>

                <Box sx={{ justifyContent: 'space-between', display: 'flex' }} >
                    <Box style={{ display: 'flex' }} width={'100%'}>
                        <Space.Compact style={{ marginLeft: '01%' }} size="middle" >
                            <Form.Item style={{ width: '70%' }} label="Total/Nbr crédit" name='TotalCrebit'><Input disabled /></Form.Item>
                            <Form.Item style={{ width: '14%' }} name='NbrCrebit'><Input disabled /></Form.Item>
                        </Space.Compact>
                        <Space.Compact style={{ marginLeft: '01%' }} size="middle" >
                            <Form.Item style={{ width: '70%' }} label="Total/Nbr débit" name='TotalDebit'><Input disabled /></Form.Item>
                            <Form.Item style={{ width: '14%' }} name='Nbrdebit'><Input disabled /></Form.Item>
                        </Space.Compact>
                        <Space.Compact style={{ marginLeft: '01%' }} size="middle" >
                            <Form.Item label='Total/Nbre' style={{ width: '70%' }} name='Total'><Input disabled /></Form.Item>
                            <Form.Item style={{ width: '14%' }} name='NbrOpe'><Input disabled /></Form.Item>
                        </Space.Compact>
                    </Box>
                    <Box>
                        <Button
                         disabled={DataInteret.length <= 0 || loading === true ? true : false} 
                         size='medium' variant="contained" type="button" onClick={e => { HandlerPrint() }} startIcon={<DataSaverOn />}>Aperçu</Button>
                    </Box>
                </Box>
            </Box>
            
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading} >
                <CircularProgress color="inherit" />
            </Backdrop>

            <ExcelExport filterable={true} data={DataExcel} fileName="AnyInteret.xlsx" ref={_exporter} onExportComplete={handleExport}  >
                <ExcelExportColumn field="AEDUCP" title="AGENCE" locked={true} width={100} headerCellOptions={headerCellStyle} />
                <ExcelExportColumn field="AEDUCP" title="AGENCE" locked={true} width={100} headerCellOptions={headerCellStyle} />
                <ExcelExportColumn field="NODUCP" title="NUMCPT" locked={true} width={150} />
                <ExcelExportColumn title="NUMCLI" field="numcli" width={150} locked={true} />
                <ExcelExportColumn title="MONTAN" field="MONTAN" width={80} locked={true} />
                <ExcelExportColumn title="REPECE" field="REPECE" width={150} locked={true} />
                <ExcelExportColumn title="SENSEC" field="SENSEC" locked={true} />
                <ExcelExportColumn title="TXMONT" field="TXMONT" />
                <ExcelExportColumn title="LIBELL" field="LIBELL" width={300} />
                <ExcelExportColumn title="INTAUX" field="INTAUX" width={100} />
                <ExcelExportColumn title="MONTFRAIS" field="montfrais" width={100} />
                <ExcelExportColumn title="SOLDVEILLE" field="solvei" width={100} />
                <ExcelExportColumn title="UTISAI" field="UTISAI" width={100} />
            </ExcelExport>

        </div>
    );
}

export default Tab2;